// FETCH CONTRACTS
export const FETCH_CONTRACTS_REQUEST = 'FETCH_CONTRACTS_REQUEST';
export const FETCH_CONTRACTS_SUCCESS = 'FETCH_CONTRACTS_SUCCESS';
export const FETCH_CONTRACTS_FAIL = 'FETCH_CONTRACTS_FAIL';
// FETCH CONTRACT
export const FETCH_CONTRACT_REQUEST = 'FETCH_CONTRACT_REQUEST';
export const FETCH_CONTRACT_SUCCESS = 'FETCH_CONTRACT_SUCCESS';
export const FETCH_CONTRACT_FAIL = 'FETCH_CONTRACT_FAIL';
// FETCH CONTRACT
export const FETCH_QUOTE_REQUEST = 'FETCH_QUOTE_REQUEST';
export const FETCH_QUOTE_SUCCESS = 'FETCH_QUOTE_SUCCESS';
export const FETCH_QUOTE_FAIL = 'FETCH_QUOTE_FAIL';
// LOAD MORE CONTRACTS
export const LOAD_MORE_CONTRACTS_REQUEST = 'LOAD_MORE_CONTRACTS_REQUEST';
export const LOAD_MORE_CONTRACTS_SUCCESS = 'LOAD_MORE_CONTRACTS_SUCCESS';
export const LOAD_MORE_CONTRACTS_FAIL = 'LOAD_MORE_CONTRACTS_FAIL';
// FETCH CONTRACT_STATUS
export const FETCH_CONTRACT_STATUS_REQUEST = 'FETCH_CONTRACT_STATUS_REQUEST';
export const FETCH_CONTRACT_STATUS_SUCCESS = 'FETCH_CONTRACT_STATUS_SUCCESS';
export const FETCH_CONTRACT_STATUS_FAIL = 'FETCH_CONTRACT_STATUS_FAIL';
// FETCH CONTRACT_EVENT
export const FETCH_CONTRACT_EVENTS_REQUEST = 'FETCH_CONTRACT_EVENTS_REQUEST';
export const FETCH_CONTRACT_EVENTS_SUCCESS = 'FETCH_CONTRACT_EVENTS_SUCCESS';
export const FETCH_CONTRACT_EVENTS_FAIL = 'FETCH_CONTRACT_EVENTS_FAIL';
// FETCH CONTRACT_DOCUMENTS
export const FETCH_CONTRACT_DOCUMENTS_REQUEST = 'FETCH_CONTRACT_DOCUMENTS_REQUEST';
export const FETCH_CONTRACT_DOCUMENTS_SUCCESS = 'FETCH_CONTRACT_DOCUMENTS_SUCCESS';
export const FETCH_CONTRACT_DOCUMENTS_FAIL = 'FETCH_CONTRACT_DOCUMENTS_FAIL';
// FETCH CONTRACT_BENEFICIARIES
export const FETCH_CONTRACT_BENEFICIARIES_REQUEST = 'FETCH_CONTRACT_BENEFICIARIES_REQUEST';
export const FETCH_CONTRACT_BENEFICIARIES_SUCCESS = 'FETCH_CONTRACT_BENEFICIARIES_SUCCESS';
export const FETCH_CONTRACT_BENEFICIARIES_FAIL = 'FETCH_CONTRACT_BENEFICIARIES_FAIL';
// FETCH CONTRACT_ATTACHMENTS
export const FETCH_CONTRACT_ATTACHMENTS_REQUEST = 'FETCH_CONTRACT_ATTACHMENTS_REQUEST';
export const FETCH_CONTRACT_ATTACHMENTS_SUCCESS = 'FETCH_CONTRACT_ATTACHMENTS_SUCCESS';
export const FETCH_CONTRACT_ATTACHMENTS_FAIL = 'FETCH_CONTRACT_ATTACHMENTS_FAIL';
// ADD CONTRACT_DOCUMENT
export const ADD_CONTRACT_DOCUMENT_REQUEST = 'ADD_CONTRACT_DOCUMENT_REQUEST';
export const ADD_CONTRACT_DOCUMENT_SUCCESS = 'ADD_CONTRACT_DOCUMENT_SUCCESS';
export const ADD_CONTRACT_DOCUMENT_FAIL = 'ADD_CONTRACT_DOCUMENT_FAIL';
// ADD CONTRACT_DOCUMENT
export const ADD_CONTRACT_ATTACHMENT_REQUEST = 'ADD_CONTRACT_ATTACHMENT_REQUEST';
export const ADD_CONTRACT_ATTACHMENT_SUCCESS = 'ADD_CONTRACT_ATTACHMENT_SUCCESS';
export const ADD_CONTRACT_ATTACHMENT_FAIL = 'ADD_CONTRACT_ATTACHMENT_FAIL';
// DELETE CONTRACT_DOCUMENT
export const DELETE_CONTRACT_DOCUMENT_REQUEST = 'DELETE_CONTRACT_DOCUMENT_REQUEST';
export const DELETE_CONTRACT_DOCUMENT_SUCCESS = 'DELETE_CONTRACT_DOCUMENT_SUCCESS';
export const DELETE_CONTRACT_DOCUMENT_FAIL = 'DELETE_CONTRACT_DOCUMENT_FAIL';
// DELETE CONTRACT_ATTACHMENT
export const DELETE_CONTRACT_ATTACHMENT_REQUEST = 'DELETE_CONTRACT_ATTACHMENT_REQUEST';
export const DELETE_CONTRACT_ATTACHMENT_SUCCESS = 'DELETE_CONTRACT_ATTACHMENT_SUCCESS';
export const DELETE_CONTRACT_ATTACHMENT_FAIL = 'DELETE_CONTRACT_ATTACHMENT_FAIL';
// SUBMIT QUOTE
export const SUBMIT_QUOTE_REQUEST = 'SUBMIT_QUOTE_REQUEST';
export const SUBMIT_QUOTE_SUCCESS = 'SUBMIT_QUOTE_SUCCESS';
export const SUBMIT_QUOTE_FAIL = 'SUBMIT_QUOTE_FAIL';
// CRYPTOLOG SIGN
export const CRYPTOLOG_SIGN_REQUEST = 'CRYPTOLOG_SIGN_REQUEST';
export const CRYPTOLOG_SIGN_SUCCESS = 'CRYPTOLOG_SIGN_SUCCESS';
export const CRYPTOLOG_SIGN_FAIL = 'CRYPTOLOG_SIGN_FAIL';
// CRYPTOLOG CHECK
export const CRYPTOLOG_CHECK_REQUEST = 'CRYPTOLOG_CHECK_REQUEST';
export const CRYPTOLOG_CHECK_SUCCESS = 'CRYPTOLOG_CHECK_SUCCESS';
export const CRYPTOLOG_CHECK_FAIL = 'CRYPTOLOG_CHECK_FAIL';
// CREATE NOTE
export const CREATE_CONTRACT_NOTE_REQUEST = 'CREATE_CONTRACT_NOTE_REQUEST';
export const CREATE_CONTRACT_NOTE_SUCCESS = 'CREATE_CONTRACT_NOTE_SUCCESS';
export const CREATE_CONTRACT_NOTE_FAIL = 'CREATE_CONTRACT_NOTE_FAIL';
// GET NOTES
export const FETCH_CONTRACT_NOTES_REQUEST = 'FETCH_CONTRACT_NOTES_REQUEST';
export const FETCH_CONTRACT_NOTES_SUCCESS = 'FETCH_CONTRACT_NOTES_SUCCESS';
export const FETCH_CONTRACT_NOTES_FAIL = 'FETCH_CONTRACT_NOTES_FAIL';
// GET NOTE
export const FETCH_CONTRACT_NOTE_REQUEST = 'FETCH_CONTRACT_NOTE_REQUEST';
export const FETCH_CONTRACT_NOTE_SUCCESS = 'FETCH_CONTRACT_NOTE_SUCCESS';
export const FETCH_CONTRACT_NOTE_FAIL = 'FETCH_CONTRACT_NOTE_FAIL';
// DOWNLOAD ATTACHMENT
export const DOWNLOAD_ATTACHMENT_REQUEST = 'DOWNLOAD_ATTACHMENT_REQUEST';
export const DOWNLOAD_ATTACHMENT_SUCCESS = 'DOWNLOAD_ATTACHMENT_SUCCESS';
export const DOWNLOAD_ATTACHMENT_FAIL = 'DOWNLOAD_ATTACHMENT_FAIL';
// UPLOAD DOCUMENT REQUEST LINE
export const UPDATE_DOCUMENT_REQUEST_LINE_REQUEST = 'UPDATE_DOCUMENT_REQUEST_LINE_REQUEST';
export const UPDATE_DOCUMENT_REQUEST_LINE_SUCCESS = 'UPDATE_DOCUMENT_REQUEST_LINE_SUCCESS';
export const UPDATE_DOCUMENT_REQUEST_LINE_FAIL = 'UPDATE_DOCUMENT_REQUEST_LINE_FAIL';
